import { render, staticRenderFns } from "./ViewOnServer.vue?vue&type=template&id=2002179c&scoped=true"
import script from "./ViewOnServer.vue?vue&type=script&lang=js"
export * from "./ViewOnServer.vue?vue&type=script&lang=js"
import style0 from "./ViewOnServer.vue?vue&type=style&index=0&id=2002179c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002179c",
  null
  
)

export default component.exports